import { Loading } from "@/components/overlays/Loading";
import { METABASE_INSTANCE_URL } from "@/lib/metabase";
import Script from "next/script";
import { useState } from "react";
declare global {
  interface Window {
    metabaseConfig?: {
      isGuest: boolean;
      instanceUrl: string;
    };
  }
}
export interface MetabaseEmbedFrameProps {
  token?: string;
  instanceUrl?: string;
  /**
   * Changing this remounts the `<metabase-dashboard>` element. The custom element is
   * not documented to reload when its `token` attribute is mutated in place, so a
   * remount is the reliable way to apply new locked parameters.
   */
  frameKey?: string;
}

/**
 * Renders the Metabase guest-embed custom element for an already-minted token.
 * Token acquisition differs per caller (viewer vs. admin preview), so it lives in the
 * components that wrap this one.
 */
export const MetabaseEmbedFrame = ({
  token,
  instanceUrl = METABASE_INSTANCE_URL,
  frameKey
}: MetabaseEmbedFrameProps) => {
  const [isScriptReady, setIsScriptReady] = useState(false);
  return <div className="flex h-full w-full flex-col" data-sentry-component="MetabaseEmbedFrame" data-sentry-source-file="MetabaseEmbedFrame.tsx">
      <Script id="metabase-guest-config" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `window.metabaseConfig = ${JSON.stringify({
        isGuest: true,
        instanceUrl
      })};`
    }} data-sentry-element="Script" data-sentry-source-file="MetabaseEmbedFrame.tsx" />
      <Script src={`${instanceUrl}/app/embed.js`} strategy="afterInteractive" onReady={() => setIsScriptReady(true)} data-sentry-element="Script" data-sentry-source-file="MetabaseEmbedFrame.tsx" />
      {isScriptReady && token ? <metabase-dashboard key={frameKey} token={token} with-title="true" style={{
      display: "block",
      height: "100%",
      width: "100%"
    }} /> : <Loading isOpaque={true} />}
    </div>;
};